export const en = {
    title: 'Add the service to',
    description: 'After adding the service, participants must independently submit an application for registration',
    add_service_error_message: 'Failed to add service',
};
